const l1Roles = [
  'l1_hardware_support_team',
  'l1_os_support_team',
  'l1_non_monitored_support',
  'l1_app_support_team',
];

const l2Roles = [
  'l2e_mongo_db_engr',
  'l2e_oracle_db_engr',
  'l2e_mssql_db_engr',
  'l2e_mysql_db_engr',
  'l2e_linux_sys_engr',
  'l2e_win_sys_engr',
];

const dbRoles = [
  'l1_db_support_team',
  'l2e_cassandra_db_engr',
  'l2e_couchbase_db_engr',
  'l2e-elasticSearch_db_engr',
  'l2e_redis_db_engr',
  'l2e_victoria_metrics_db_engineer',
];

const isDbRole = (roleName: string): boolean => {
  if (dbRoles.includes(roleName)) {
    return true;
  }
  return false;
};

const isL1Support = (roleName: string): boolean => {
  if (l1Roles.includes(roleName)) {
    return true;
  }
  return false;
};

const isL2Support = (roleName: string): boolean => {
  if (l2Roles.includes(roleName)) {
    return true;
  }
  return false;
};

/**
 * Check if the role is a support role
 * @param roleName the role name
 */
export const isSupportRole = (roleName: string): boolean => {
  if (!roleName) {
    return false;
  }

  return isDbRole(roleName) || isL1Support(roleName) || isL2Support(roleName);
};

/**
 * Get the support role url
 * @param role the role name
 */
export const supportRoleUrl = (role: string): string => {
  if (l1Roles.includes(role)) {
    return 'https://tpx.sys.comcast.net/plugins/servlet/com.thinktilt.proforma.add-on/create-issue-direct?ac.form.id=5&ac.issuetype.id=10800&project.key=CAIS';
  }
  if (l2Roles.includes(role) || dbRoles.includes(role)) {
    return 'https://techspot.comcast.com/iop?id=sc_category&sys_id=f503928f1b4e21d4529f6461604bcb76&catalog_id=742ce428d7211100f2d224837e61036d&spa=1';
  }

  return '';
};
